<template>
  <section class="w-full">
  <div class="slot-jackpot xs-section">
    <div class="grid-container">
      <div class="slide-section">
        <v-slide-group
          v-model="selectedJackpot"
          class="custom-slide-group"
          active-class="active"
          ref="slideGroup"
          show-arrows
        >
        <!-- v-for="list in [...jackpotList,...jackpotList]" -->
          <v-slide-item
            v-for="list in jackpotList"
            :key="list.Id"
            :value="list.Id"
            v-slot="{ toggle }"
          >
            <div
              class="jackpot-box cursor-pointer"
              @click="handleJackpotClick(list.Id, toggle)"
            >
              {{ list.id }}
              <div class="jackpot-total">
                <v-icon></v-icon>
                <p>1.4k</p>
              </div>
              <img
                :src="list.ImagePath"
                :alt="list.Name"
                @error="onImageError($event)"
              />
              <div class="jackpot-num" v-if="hasJackpotAmount(list)">
                <div class="jackpot-levels">
                  <div class="jackpot-row">
                    <p
                      v-for="(level, index) in getJackpotLevels(list).firstRow"
                      :key="'first-' + index"
                      :class="['level-display', getLevelClass(index)]"
                    >
                      ${{ level.amount.toLocaleString() }}
                    </p>
                  </div>
                  <div
                    class="jackpot-row"
                    v-if="getJackpotLevels(list).secondRow.length"
                  >
                    <p
                      v-for="(level, index) in getJackpotLevels(list).secondRow"
                      :key="'second-' + index"
                      :class="['level-display', getLevelClass(index + 1)]"
                    >
                      ${{ level.amount.toLocaleString() }}
                    </p>
                  </div>
                  <div
                    class="jackpot-row"
                    v-if="getJackpotLevels(list).thirdRow.length"
                  >
                    <p
                      v-for="(level, index) in getJackpotLevels(list).thirdRow"
                      :key="'third-' + index"
                      :class="['level-display', getLevelClass(index + 3)]"
                    >
                      ${{ level.amount.toLocaleString() }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="jackpot-alone" v-else>
                <p>STAND ALONE</p>
              </div>
            </div>
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import { GameActions, GameNamespace } from "@/store/game";
import { JackpotActions, JackpotNamespace } from "@/store/jackpot";
import { mapActions, mapGetters } from "vuex";
import pageMixin from "@/mixins/pageMixin";

export default {
  mixins: [pageMixin],
  data() {
    return {
      selectedJackpot: "all",
    };
  },
  computed: {
    ...mapGetters(GameNamespace, ["getGameList"]),
    ...mapGetters(JackpotNamespace, ["getJackpotList"]),

    jackpotList() {
      return this.getJackpotList || []; // 기존 리스트 그대로 사용 (순서 변경 X)
    },

    gameList() {
      return this.getGameList || []; // 게임 리스트가 없을 때 빈 배열 반환
    },
  },
  mounted() {
    this.ACTION_READ_GAME_LIST();
    this.ACTION_READ_JACKPOT_LIST();
  },
  methods: {
    ...mapActions(GameNamespace, {
      ACTION_READ_GAME_LIST: GameActions.ACTION_READ_GAME_LIST,
    }),
    ...mapActions(JackpotNamespace, {
      ACTION_READ_JACKPOT_LIST: JackpotActions.ACTION_READ_JACKPOT_LIST,
    }),

    handleJackpotClick(jackpotId) {
      if (this.selectedJackpot !== jackpotId) {
        this.selectedJackpot = jackpotId;
        this.updateSelectedJackpot(jackpotId);
      }else{
        this.selectedJackpot = "all";
        this.updateSelectedJackpot("all");
      }
    },

    hasJackpotAmount(list) {
      return (
        list.Level1Amount > 0 ||
        list.Level2Amount > 0 ||
        list.Level3Amount > 0 ||
        list.Level4Amount > 0 ||
        list.Level5Amount > 0 ||
        list.Level6Amount > 0
      );
    },
    getLevelClass(index) {
      return `level-${index + 1}`;
    },
    getJackpotLevels(list) {
      const levels = [];
      if (list.Level1Amount > 0) levels.push({ amount: list.Level1Amount });
      if (list.Level2Amount > 0) levels.push({ amount: list.Level2Amount });
      if (list.Level3Amount > 0) levels.push({ amount: list.Level3Amount });
      if (list.Level4Amount > 0) levels.push({ amount: list.Level4Amount });
      if (list.Level5Amount > 0) levels.push({ amount: list.Level5Amount });
      if (list.Level6Amount > 0) levels.push({ amount: list.Level6Amount });

      const levelCount = levels.length;
      let firstRow = [];
      let secondRow = [];
      let thirdRow = [];

      if (levelCount === 1) {
        firstRow = levels;
      } else if (levelCount === 2) {
        firstRow = levels.slice(0, 1);
        secondRow = levels.slice(1, 2);
      } else if (levelCount === 3) {
        firstRow = levels.slice(0, 1);
        secondRow = levels.slice(1, 3);
      } else if (levelCount === 4) {
        firstRow = levels.slice(0, 2);
        secondRow = levels.slice(2, 4);
      } else if (levelCount === 5) {
        firstRow = levels.slice(0, 1);
        secondRow = levels.slice(1, 3);
        thirdRow = levels.slice(3, 5);
      } else if (levelCount === 6) {
        firstRow = levels.slice(0, 2);
        secondRow = levels.slice(2, 4);
        thirdRow = levels.slice(4, 6);
      }

      return {
        firstRow,
        secondRow,
        thirdRow,
      };
    },
    onImageError(event) {
      event.target.src = this.defaultJackpotImage; // 이미지 로드 실패 시 기본 이미지 설정
    },
  },
};
</script>


<style lang="scss" scoped>
</style>



<style lang="scss">
#main_page{
  .v-slide-group__wrapper {
    padding: 1rem 0px;
  }
}
</style>